<template>
<div style="width:81.5vw">
  <div class="mt-6 ml-4 flex space-between space-x-4 justify-between m-2 mr-4 flex-end">
    <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
        {{ t('sidebar.thirdPartyIntegrations') }}
      </h1>
      <h1 class="text text-gray-900 dark:text-gray-200" style="font-size: 16px;">
        {{ t('thirdPartyIntegrationsPage.subtitle') }}
      </h1>
    </div>
  </div>

  



  <CollapsingCard :title="t('thirdPartyIntegrationsPage.didAvatar.title')" :subtitle="t('thirdPartyIntegrationsPage.didAvatar.subtitle')" icon="ic:sharp-person" class="ml-2 mr-2 mt-4">
    <div class="mb-4">
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{{ t('thirdPartyIntegrationsPage.didAvatar.apiKeyLabel') }}</label>
          <input 
            v-model="didAvatarConfig.apiKey" 
            type="password" 
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            :placeholder="t('thirdPartyIntegrationsPage.didAvatar.apiKeyPlaceholder')"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{{ t('thirdPartyIntegrationsPage.didAvatar.avatarIdLabel') }}</label>
          <input 
            v-model="didAvatarConfig.avatarId" 
            type="text" 
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            :placeholder="t('thirdPartyIntegrationsPage.didAvatar.avatarIdPlaceholder')"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{{ t('thirdPartyIntegrationsPage.didAvatar.voiceIdLabel') }}</label>
          <input 
            v-model="didAvatarConfig.voiceId" 
            type="text" 
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            :placeholder="t('thirdPartyIntegrationsPage.didAvatar.voiceIdPlaceholder')"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{{ t('thirdPartyIntegrationsPage.didAvatar.backgroundColorLabel') }}</label>
          <input 
            v-model="didAvatarConfig.backgroundColor" 
            type="color" 
            class="w-full h-10 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
        </div>
        <div class="flex items-center space-x-4">
         
          <button 
            @click="saveDidAvatarConfig" 
            class="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors duration-200"
          >
            {{ t('thirdPartyIntegrationsPage.didAvatar.saveButton') }}
          </button>
        </div>
      </div>
    </div>
  </CollapsingCard>

</div>
  

</template>
<script setup>
import { ref, onMounted } from 'vue';
import EasyDataTable from "vue3-easy-data-table";
import Multiselect from '@vueform/multiselect';
import { SelectPageList } from 'v-selectpage';
import { cond } from 'lodash';
import CollapsingCard from '@/components/CollapsingCard.vue';
import ConversationAnalysisWebhook from '@/components/ConversationAnalysisWebhook.vue';
import { Icon } from "@iconify/vue/dist/offline";
import { isDefinedAndNotEmpty } from '../../isDefinedAndNotEmpty.js';
import { useI18n } from '@/i18n';
import en from '@/locales/en.json';
const { t } = useI18n({ locale: 'en', messages: { en } });
import { useToast } from 'vue-toastification';
const toast = useToast();

const searchFields = ["contactCenterID", "contactCenterName"];

const searchValue = ref("");

const roiInsights = ref(null);

const didAvatarConfig = ref({
  apiKey: '',
  avatarId: '',
  voiceId: '',
  backgroundColor: '#ffffff'
});

onMounted(function(){
  fetchROIInsights();
});

async function fetchROIInsights(){
  setTimeout(() => { 
    roiInsights.value= {
  "insights":[
    {
      "type":"warning",
      "htmlContent":`
        <span>לאחרונה
        <div class="font-bold inline-block">15%</div>
        מהפונים למוקד השירות "מרפאת בני ברק"
        <div class="font-bold inline-block">ביקשו לעזוב את השירות</div>
        עקב תלונות על רופא גבר לרופאי הנשים, עקב היותם דתיים.
      </span>
      `
    },
    {
      "type":"info",
      "htmlContent":`
        <span>נציגי השירות מבזבזים 
        <div class="font-bold inline-block">25%</div>
        אחוז מהשיחה
        <div class="font-bold inline-block">בממוצע 1.5 דקות</div>
       לברר מידע על הנושאים הבאים:
       
        ממליצים להוסיף מידע לשירות Agent Assistance וכך הנציגים יוכלו לשאול בצאט את הAI ויקבלו תשובה במהירות ובקלות
      </span>
      `,
      "buttonSettings":{
        "buttonText":"Agent Assistance",
        "action":"goToAgentAssistance"
      }
    }
  ]
 }

   }, 500);
  
}

const headers = [
  { text: "ID", value: "contactCenterID", sortable: true },
  { text: "Name", value: "contactCenterName", sortable: true },
  { text: "Teams", value: "contactCenterTeams" },
  { text: "Options", value: "options" }

];





let contactCentersDebug = ref([
  {
    "contactCenterGuid": "0a1a65c7-0db4-467b-9818-71d06f019856",
    "contactCenterID": "1",
    "contactCenterName": "מוקד שירות ראשי",
    "contactCenterTeams": [{
      "teamName": "צוות שכר"
    },
    {
      "teamName": "צוות תמיכה"
    }]
  },
  {
    "contactCenterGuid": "0a1a65c7-0db4-467b-9818-71d06f019856",
    "contactCenterID": "2",
    "contactCenterName": "מוקד שירות לתמיכה באייפון",
    "contactCenterTeams": [{
      "teamName": "צוות שכר"
    },
    {
      "teamName": "צוות תמיכה"
    }]
  }

]);



onMounted(() => {
  loadStyle(`
.vue3-easy-data-table {
  height: 95%;
}
.sp-trigger-container.sp-opened{
  box-shadow:none;
}
  .dp__main{
    width:262px;
    height:100%;
  }
    .sp-trigger-container .sp-trigger.sp-chips{
    max-height: 1.8rem;
    overflow: auto;
    }
    .sp-trigger-container{
      height:3rem;
    }
    .dp__main input {
     padding-left:17%;
    border-color: #dadcdf;
    flex-shrink: 1;
    appearance: none;
    height: 3rem;
    width:260px;
    font-size: 1rem;
    line-height: 2;
    line-height: 1.5rem;
    border-radius: var(--rounded-btn, .5rem);
    border-width: 1px;
    
    --tw-bg-opacity: 1;
    background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
    }

    .multiselect{
      height:3rem;
      width: 180px;
      margin-right:1%;
    }
  `);

  loadDidAvatarConfig();
})
function loadStyle(cssString) {

  const style = document.createElement('style');


  style.type = 'text/css';


  if (style.styleSheet != null) {
    style.styleSheet.cssText = cssString;
  } else {

    style.appendChild(document.createTextNode(cssString));
  }


  document.head.appendChild(style);
}
function detectTextDirection(text) {
  const rtlChars = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  return rtlChars.test(text) === true ? 'rtl' : 'ltr';
}
function textDirectionClass(text) {
  return detectTextDirection(text) === 'rtl' ? 'text-rtl heebo-text' : 'text-ltr';
}

async function testDidAvatar() {
  try {
    const response = await fetch('/api/test-did-avatar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(didAvatarConfig.value)
    });
    
    if (response.ok != false) {
      toast.success(t('thirdPartyIntegrationsPage.didAvatar.toasts.testSuccess'));
    } else {
      toast.error(t('thirdPartyIntegrationsPage.didAvatar.toasts.testError'));
      throw new Error('Avatar test failed');
    }
  } catch (error) {
    toast.error(t('thirdPartyIntegrationsPage.didAvatar.toasts.testError'));
    console.error('Failed to test avatar:', error);
  }
}

async function saveDidAvatarConfig() {
  try {
    const response = await fetch('/api/save-did-avatar-config', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(didAvatarConfig.value)
    });
    
    if (response.ok != false) {
      toast.success(t('thirdPartyIntegrationsPage.didAvatar.toasts.saveSuccess'));
    } else {
      toast.error(t('thirdPartyIntegrationsPage.didAvatar.toasts.saveError'));
      throw new Error('Failed to save configuration');
    }
  } catch (error) {
    toast.error(t('thirdPartyIntegrationsPage.didAvatar.toasts.saveError'));
    console.error('Failed to save configuration:', error);
  }
}

async function loadDidAvatarConfig() {
  try {
    const response = await fetch('/api/load-did-avatar-config');
    if (response.ok != false) {
      const config = await response.json();
      didAvatarConfig.value = { ...didAvatarConfig.value, ...config };
    }
  } catch (error) {
    toast.error(t('thirdPartyIntegrationsPage.didAvatar.toasts.loadError'));
    console.error('Failed to load DiD Avatar configuration:', error);
  }
}

</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
table {
  font-family: "Heebo", sans-serif !important;
}
</style>

